import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "nav_l"
};
const _hoisted_2 = {
  class: "tab"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "nav_r"
};
const _hoisted_5 = {
  style: {
    "margin": "0 12px"
  }
};
const _hoisted_6 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_popup = _resolveComponent("popup");
  const _component_headerPcM = _resolveComponent("headerPcM");
  return $setup.Client == 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "nav",
    style: _normalizeStyle('zoom:' + ($setup.Client ? '20%' : '') + ';')
  }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_image, {
    width: "150",
    src: "https://www.mimodental.com/assets/imgData/img/header/logo.png",
    onClick: _cache[0] || (_cache[0] = $event => $setup.nav_to('home')),
    style: {
      "cursor": "pointer"
    }
  }), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tabList, item => {
    return _openBlock(), _createElementBlock("span", {
      key: item.key,
      style: _normalizeStyle('color:' + ($setup.key == item.key ? '#13A4BF' : '')),
      onClick: $event => $setup.nav_to(item.key)
    }, _toDisplayString(item.name), 13, _hoisted_3);
  }), 128))])]), _cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "nav_c"
  }, null, -1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", {
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.userInfo && $setup.userInfo(...args))
  }, "会员服务"), _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_icon, {
    name: "https://www.mimodental.com/assets/imgData/img/header/user.png"
  }), !$setup.userData ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    style: {
      "margin-left": "5px"
    },
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.login && $setup.login(...args))
  }, "登录/注册")) : (_openBlock(), _createElementBlock("span", {
    key: 1,
    style: {
      "margin-left": "5px"
    },
    class: "userName",
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.logOff && $setup.logOff(...args))
  }, _toDisplayString($setup.userData.phone), 1))])]), _createVNode(_component_popup, {
    show: $setup.loginShow,
    showState: $setup.showState,
    onModifyShowState: $setup.modifyShowState,
    onGetUserData: $setup.getUserData
  }, null, 8, ["show", "showState", "onModifyShowState", "onGetUserData"])], 4)) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_headerPcM)]));
}